<template>
  <div class="products grid-products" :class="[ products.length > 1 ? '' : 'onlyOne']">
    <!-- v-for  -->
    <transition-group name="fade">
      <Product
        v-for="(product, index) in products"
        :prod="product"
        :key="index"/>
    </transition-group>

<!--     <transition-group name="fade">
      <OrderCard
        v-if="showOrderCard"
        :key="orderProduct.id"
        :prod="orderProduct"
        :orderType="orderType"/>
    </transition-group> -->

  </div>
</template>

<script>

import Product from './Product.vue';
import OrderCard from './OrderCard.vue';

export default {
  name: 'Products',
  data() {
    return {}
  },
  props: {
    products: Array,
  },
  components: {
    Product,
    OrderCard,
  },
  computed: {
    showOrderCard() {
      return this.$root.$data.state.showOrderCard;
    },
    orderProduct() {
      return this.$root.$data.state.orderProduct;
    },
    orderType() {
      return this.$root.$data.state.orderType;
    },
    popupActive() {
      return this.$root.$data.state.popupActive;
    }
  },
  mounted: function() {
    // this._closeCard = () => {
    //   console.log('we here');
    //   this.popupActive = false;
    //   this.orderProduct = null;
    //   this.showOrderCard = false;
    // }
    // this.$bus.$on('orderSent', this._closeCard);
  },
  beforeDestroy: function() {
    // this._closeCard && this.$bus.$off('cardSent', this._closeCard);
  },
  methods: {
    closeOrderCard() {
      console.log('closing order card');
    },
    // Not needed for now
    rProduct(id) {
      console.log(`removing ${id}`);
      const products = this.$root.$data.state.products;
      const productToRemove = products.findIndex(function(prod) {
        return prod.id == id;
      });
      console.log(`removing index: ${productToRemove}`);
      products.splice(productToRemove, 1);
    }
  }
};
</script>

<style scoped lang="stylus">

@import '../styles/common.styl'

.products
  position relative
  margin 25px 0px
  // column-count 3
  // column-gap 1em
  &>span
    display flex
    flex-wrap wrap
    @supports (display: grid)
      display grid
      grid-template-columns repeat(auto-fill, minmax(250px, 1fr))
      grid-gap 16px
      grid-auto-flow row
      grid-auto-rows 20px
    .product
      max-width 32%
      &:not(:nth-child(3n+1))
        margin-left 1%
      @supports (display: grid)
        max-width 100%
        &:not(:nth-child(3n+1))
          margin-left 0
    +mobileXS()
      display block
    +mobile()
      margin 0px 15px
  // &.onlyOne
  //   &>span 
  //     display inline-block

</style>



// WEBPACK FOOTER //
// src/components/Products.vue